import React from "react"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Block from "@bappweb/block"

const QrCode = () => {
  const appStoreLink = `https://apps.apple.com/tr/app/axess-mobil/id1270161188?l=tr`
  const googlePlayLink = `https://play.google.com/store/apps/details?id=com.akbank.android.apps.axess&hl=tr&gl=US`
  return (
    <Block className="qr-inner">
      <Element type="h3">VEYA</Element>
      <Block>
        <Element type="p">
          {"Aşağıdaki QR kodu telefonunun kamerasından okutarak da Juzdan'ı indirebilirsin"}
        </Element>
        <Block className="qr-content">
          <Image path={"./img/juzdan/qrcode.png"} />
        </Block>
      </Block>
      <Block className="store-buttons">
        <a href={appStoreLink} target="_blank" rel="noopener noreferrer">
          <Image className="app-store" path={"./img/juzdan/app-store.png"} />
          <span>App Store</span>
          {"'dan İndir"}
        </a>
        <a href={googlePlayLink} target="_blank" rel="noopener noreferrer">
          <Image className="google-play" path={"./img/juzdan/google-play.png"} />
          <span>Google Play</span>
          {"'den İndir"}
        </a>
      </Block>
    </Block>
  )
}

export default QrCode
